<sans-shared-hamburger-menu>
  <sans-language-icon [isHamburgerMenuItem]="true"></sans-language-icon>

<!--  <sans-theme-icon [isHamburgerMenuItem]="true"></sans-theme-icon>-->

  <sans-leave-game-play
    [isHamburgerMenuItem]="true"
    [gamePlayId]="gamePlayId"
  ></sans-leave-game-play>
</sans-shared-hamburger-menu>
